import { type Static, Type } from "@sinclair/typebox"
import { SCOPE_KEY_REGEX } from "../scopes"
import { CursorQuerySchema, createPageSchema, IsoDateTimeSchema, Nullable } from "./common"

// Roles y scopes — docs/04 §3 y docs/03 §3.

export const ScopeKeySchema = Type.String({ pattern: SCOPE_KEY_REGEX.source })

export const ScopeSchema = Type.Object({
  id: Type.String(),
  // null = scope global de la instancia
  domain_id: Nullable(Type.String()),
  key: ScopeKeySchema,
  description: Nullable(Type.String()),
  created_at: IsoDateTimeSchema,
  updated_at: IsoDateTimeSchema,
})
export type Scope = Static<typeof ScopeSchema>

export const RoleSchema = Type.Object({
  id: Type.String(),
  // null = rol de sistema
  domain_id: Nullable(Type.String()),
  name: Type.String(),
  description: Nullable(Type.String()),
  is_system: Type.Boolean(),
  // Keys de los scopes agrupados por el rol
  scopes: Type.Array(ScopeKeySchema),
  created_at: IsoDateTimeSchema,
  updated_at: IsoDateTimeSchema,
})
export type Role = Static<typeof RoleSchema>

export const ListRolesQuerySchema = Type.Composite([
  CursorQuerySchema,
  Type.Object({
    domain: Type.Optional(Type.String()),
    q: Type.Optional(Type.String()),
    // Al acotar por `domain` (solo admin de instancia), incluye además los roles
    // globales/de sistema (domain_id null). Lo usa el selector de roles del usuario,
    // donde un usuario del dominio puede recibir tanto roles del dominio como globales.
    include_global: Type.Optional(Type.Boolean()),
  }),
])
export type ListRolesQuery = Static<typeof ListRolesQuerySchema>

export const ListScopesQuerySchema = ListRolesQuerySchema
export type ListScopesQuery = Static<typeof ListScopesQuerySchema>

export const RolePageSchema = createPageSchema(RoleSchema)
export type RolePage = Static<typeof RolePageSchema>

export const ScopePageSchema = createPageSchema(ScopeSchema)
export type ScopePage = Static<typeof ScopePageSchema>

// Los maestros crean roles solo en su dominio (el servidor fija domain_id).
export const CreateRoleRequestSchema = Type.Object({
  name: Type.String({ minLength: 1 }),
  description: Type.Optional(Type.String()),
  scope_ids: Type.Optional(Type.Array(Type.String())),
})
export type CreateRoleRequest = Static<typeof CreateRoleRequestSchema>

export const UpdateRoleRequestSchema = Type.Object({
  name: Type.Optional(Type.String({ minLength: 1 })),
  description: Type.Optional(Nullable(Type.String())),
})
export type UpdateRoleRequest = Static<typeof UpdateRoleRequestSchema>

// PUT /admin/roles/{id}/scopes — la matriz roles×scopes reemplaza el conjunto.
export const ReplaceRoleScopesRequestSchema = Type.Object({
  scope_ids: Type.Array(Type.String()),
})
export type ReplaceRoleScopesRequest = Static<typeof ReplaceRoleScopesRequestSchema>

export const CreateScopeRequestSchema = Type.Object({
  key: ScopeKeySchema,
  description: Type.Optional(Type.String()),
})
export type CreateScopeRequest = Static<typeof CreateScopeRequestSchema>

export const UpdateScopeRequestSchema = Type.Object({
  description: Type.Optional(Nullable(Type.String())),
})
export type UpdateScopeRequest = Static<typeof UpdateScopeRequestSchema>
